// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"cb8dd8c3","479":"181967f7","884":"81a9f548","933":"c8f656da","962":"8e6d3083"}[chunkId] + ".chunk.css";
};